import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-16">
          <div className="text-center md:text-left" data-id="element-17">
            <span className="text-xl font-black text-white uppercase tracking-tighter block mb-1" data-id="element-18">
              Watson Martial Arts
            </span>
            <p className="text-sm" data-id="element-19">
              © {new Date().getFullYear()} Watson Martial Arts. All rights
              reserved.
            </p>
          </div>

          <div className="flex gap-6" data-id="element-20">
            <a href="#" className="hover:text-white transition-colors" aria-label="Facebook" data-id="element-21">
              <Facebook className="w-6 h-6" data-id="element-22" />
            </a>
            <a href="#" className="hover:text-white transition-colors" aria-label="Instagram" data-id="element-23">
              <Instagram className="w-6 h-6" data-id="element-24" />
            </a>
            <a href="#" className="hover:text-white transition-colors" aria-label="YouTube" data-id="element-25">
              <Youtube className="w-6 h-6" data-id="element-26" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}